import { Component, HostListener, OnInit } from '@angular/core';
import { BriefingMasterModel } from 'src/Models/BriefingMasterModel';
import { Router } from '@angular/router';
import { CheckAuth } from 'src/Services/utility.service';
import { ToastrService } from 'ngx-toastr';
import { Title } from '@angular/platform-browser';
import { BriefingChecklisteFilterModel } from 'src/Models/filterModel';
import { I360Service } from 'src/Services/i360Service';
import * as FileSaver from 'file-saver';
import { SessionStorageService } from 'src/common/session-storage.service';

@Component({
  selector: 'app-briefing-checklist',
  templateUrl: './briefing-checklist.component.html',
  styleUrls: ['./briefing-checklist.component.css']
})
export class BriefingchecklistComponent implements OnInit {
  filterModel = new BriefingChecklisteFilterModel();
  currentPage: number = 1;
  totalRecordCount: number = -1;

  listOfBriefing: BriefingMasterModel[];
  listOfBriefingExport: BriefingMasterModel[];

  tokenKey: string = '';
  SelectedTool: string;

  isAscending: boolean = false

  upDowUpdateDateCSS: string = '';
  upDowTitleCSS: string = '';
  upDowDueDateCSS: string = '';
  upDowIsDoneCSS: string = '';
  upDowCreatedDateCSS: string = '';

  briefingChecklistId: number = 0;
  isloading: boolean;

  isShowprogressSpinner = false;
  loginuserID: number = 0;

  dropdownListBriefingTitle = [];
  selectedItemsBriefingTitle = [];
  dropdownSettingsBriefingTitle = {};
  listOfBriefingTitleIds = [];

  openMenuIndex: number = -1

  dropdownListChecklist = [];
  selectedChecklist = [];
  dropdownSettingsChecklist = {};
  listOfChecklist = [];

  dropdownListStatus = [];
  selectedItemsStatus = [];
  dropdownSettingsStatus = {};
  listOfStatusIds = [];

  constructor(private readonly i360service: I360Service,
    private readonly router: Router,
    private readonly checkAuth: CheckAuth,
    private readonly titleService: Title,
    private readonly toastr: ToastrService,
    private sessionStorageService: SessionStorageService
  ) {
    this.tokenExpireCalculation(this.sessionStorageService.getAppStartTime(),this.sessionStorageService.getTokenExpiryValue());
    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.SelectedTool = this.sessionStorageService.getUserLoginTool();
    this.titleService.setTitle('Briefing Checklist');
    this.filterModel.pageNumber = '1';
    this.filterModel.pageSize = '10';
    this.filterModel.orderBy = 'ISNULL(bc.BriefingChecklistId,bc.BriefingId) DESC';
    this.filterModel.BriefingId = 0;
    this.filterModel.ChecklistId = "";
    this.filterModel.IsDone = 0;
    this.loginuserID = this.sessionStorageService.getAdminUserId();
  }

  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
  }

  ngOnInit() {
    this.GetBriefingTitleMasterData();
    this.GetBriefingChecklistMasterData();
    this.GetStatusMasterData();
    let BriefingTitleId = sessionStorage.getItem("BriefingTitleId");
    if (BriefingTitleId != '' && BriefingTitleId != null && BriefingTitleId != undefined) {
      this.filterModel.BriefingId = Number(BriefingTitleId);
    }
    this.GetBriefingChecklist();
  }

  GetBriefingChecklist() {
    this.isloading = true;
    this.listOfBriefing = [];
    this.filterModel.IsExport = false;
    this.i360service.GetBriefingChecklistV2(this.tokenKey, this.filterModel).subscribe(
      data => {
        this.isloading = false;
        if (data != null) {
          this.listOfBriefing = data['listOfChecklist'];
          if (this.listOfBriefing != null) {
            if (this.listOfBriefing.length > 0) {
              this.totalRecordCount = this.listOfBriefing[0].totalRecordCount;
            }
            else {
              this.totalRecordCount = 0;
            }
          }
          else {
            this.totalRecordCount = 0;
          }
        }
      },
      error => {
        this.isloading = false;
        console.log(error);
      }
    );
  }

  keywordFilters($event) {
    this.filterModel.pageNumber = '1';
    this.currentPage = 1;
    if ($event.target.value != "" && $event.target.value != null) {
      this.filterModel.filterText = $event.target.value;
    }
    else {
      this.filterModel.filterText = '';
    }
    this.GetBriefingChecklist();
  }

  pageChanged($event: any) {
    this.currentPage = $event.page;
    this.filterModel.pageNumber = parseInt($event.page).toString();
    this.GetBriefingChecklist();
  }

  sort(sortBy: any) {
    this.upDowUpdateDateCSS = '';
    this.upDowTitleCSS = '';
    this.upDowDueDateCSS = '';
    this.upDowCreatedDateCSS = '';
    this.upDowIsDoneCSS = '';

    if (!this.isAscending) {
      this.isAscending = true;
      this.filterModel.orderBy = sortBy + ' DESC';

      if (sortBy === "updateDate") {
        this.upDowUpdateDateCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "title") {
        this.upDowTitleCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "dueDate") {
        this.upDowDueDateCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "isDone") {
        this.upDowIsDoneCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "createdDate") {
        this.upDowCreatedDateCSS = 'fa fa-arrow-down';
      }
    }
    else {
      this.isAscending = false;
      this.filterModel.orderBy = sortBy;
      if (sortBy === "updateDate") {
        this.upDowUpdateDateCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "title") {
        this.upDowTitleCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "dueDate") {
        this.upDowDueDateCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "isDone") {
        this.upDowIsDoneCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "createdDate") {
        this.upDowCreatedDateCSS = 'fa fa-arrow-up';
      }
    }
    this.filterModel.pageNumber = '1';
    this.currentPage = 1;
    this.GetBriefingChecklist();
  }

  addData() {
    this.router.navigate(['admin/briefingServices/manage-checklist']);
  }

  editData(ids, type) {
    if (type == 2) {
      sessionStorage.setItem("callType", "isDone");
    }
    else {
      sessionStorage.removeItem("callType");
    }

    this.router.navigate(['admin/briefingServices/manage-checklist/' + ids])
  }

  setDeleteData(ids) {
    this.briefingChecklistId = ids;
  }

  deleteRecord(briefingChecklistId) {
    this.i360service.DeleteBriefingChecklist(this.tokenKey, briefingChecklistId).subscribe(
      data => {
        this.briefingChecklistId = 0;
        if (data != null) {
          if (data['status'] == 'Success') {
            this.GetBriefingChecklist();
            this.toastr.success('Record deleted successfully.', 'Delete')
          }
        }
      },
      error => {

      }
    );
  }

  GetBriefingTitleMasterData(): void {
    this.i360service.GetBriefingTitleMasterData(this.tokenKey).subscribe(
      data => {
        if (data["briefing"] != null && data["status"] != "Failure") {
          for (let iCounter = 0; iCounter < data["briefing"].length; iCounter++) {
            this.dropdownListBriefingTitle.push(
              { "id": data["briefing"][iCounter].briefingId, "itemName": data["briefing"][iCounter].title }
            );
          }
        }
        else {
          this.toastr.error(data["message"]);
        }
        this.dropdownSettingsBriefingTitle = {
          singleSelection: true,
          text: "Select Title(s)",
          enableSearchFilter: true,
          classes: "borderLessTextBoxGreen",
          badgeShowLimit: 2,
          noDataLabel: 'No title available',
          showCheckbox: false,
          enableFilterSelectAll: false
        };

        let BriefingTitleId = sessionStorage.getItem("BriefingTitleId");
        if (BriefingTitleId != '' && BriefingTitleId != null && BriefingTitleId != undefined) {
          if (this.dropdownListBriefingTitle.length > 0) {
            this.selectedItemsBriefingTitle = [];
            this.listOfBriefingTitleIds = [];
            let titledata = this.dropdownListBriefingTitle.filter(y => y.id == BriefingTitleId)[0];
            this.selectedItemsBriefingTitle.push({ "id": titledata.id, "itemName": titledata.itemName })
            this.listOfBriefingTitleIds.push(titledata.id);
          }



          sessionStorage.removeItem("BriefingTitleId")
        }
      }, error => {
        this.toastr.error(error);
      })
  }

  onSelectBriefingTitle($event) {
    this.listOfBriefingTitleIds = this.removeElemetninArray(this.listOfBriefingTitleIds, $event.id)
    this.listOfBriefingTitleIds.push($event.id);
    this.filterModel.BriefingId = Number($event.id);
    this.filterModel.pageNumber = '1';
    this.currentPage = 1;
    this.GetBriefingChecklist();
  }

  onDeSelectBriefingTitle($event) {
    if (this.listOfBriefingTitleIds != null) {
      if (this.listOfBriefingTitleIds.length > 0) {
        this.listOfBriefingTitleIds = this.removeElemetninArray(this.listOfBriefingTitleIds, $event.id)
      }
    }
    this.filterModel.BriefingId = 0;
    this.filterModel.pageNumber = '1';
    this.currentPage = 1;
    this.GetBriefingChecklist();
  }

  onSelectAllBriefingTitle($event) {
    for (const item of $event) {
      if (this.listOfBriefingTitleIds != null) {
        if (this.listOfBriefingTitleIds.length > 0) {
          this.listOfBriefingTitleIds = this.removeElemetninArray(this.listOfBriefingTitleIds, item.id)
          this.listOfBriefingTitleIds.push(item.id);
        }
        else {
          this.listOfBriefingTitleIds.push(item.id);
        }
      }
    }
  }

  onDeSelectAllBriefingTitle($event) {
    this.listOfBriefingTitleIds = [];
    this.filterModel.BriefingId = 0;
    this.filterModel.pageNumber = '1';
    this.currentPage = 1;
    this.GetBriefingChecklist();
  }

  removeElemetninArray(array, element) {
    return array.filter(e => e !== element);
  }

  toggleMenu(index: number) {
    this.openMenuIndex = this.openMenuIndex === index ? -1 : index;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (!target.closest('.kebab-menu')) {
      this.openMenuIndex = null;
    }
  }

  GetBriefingChecklistMasterData(): void {
    this.i360service.GetBriefingChecklistMasterData(this.tokenKey, 0).subscribe(
      data => {
        if (data["masterData"] != null && data["status"] != "Failure") {
          for (let iCounter = 0; iCounter < data["masterData"].length; iCounter++) {
            this.dropdownListChecklist.push(
              { "id": data["masterData"][iCounter].checklistId, "itemName": data["masterData"][iCounter].checklistName }
            );
          }
        }
        else {
          this.toastr.error(data["message"]);
        }
        this.dropdownSettingsChecklist = {
          singleSelection: false,
          text: "Select Checklist(s)",
          enableSearchFilter: true,
          classes: "borderLessTextBoxGreen",
          badgeShowLimit: 3,
          noDataLabel: 'No checklist available',
          showCheckbox: true
        };
      }, error => {
        this.toastr.error(error);
      })
  }

  onSelectChecklist($event) {
    this.listOfChecklist = this.removeElemetninArray(this.listOfChecklist, $event.id)
    this.listOfChecklist.push($event.id);
    this.filterModel.ChecklistId = this.listOfChecklist.toString();
    this.filterModel.pageNumber = '1';
    this.currentPage = 1;
    this.GetBriefingChecklist();
  }

  onDeSelectChecklist($event) {
    if (this.listOfChecklist != null) {
      if (this.listOfChecklist.length > 0) {
        this.listOfChecklist = this.removeElemetninArray(this.listOfChecklist, $event.id)
      }
      this.filterModel.ChecklistId = this.listOfChecklist.toString();
      this.filterModel.pageNumber = '1';
      this.currentPage = 1;
      this.GetBriefingChecklist();
    }
  }

  onSelectAllChecklist($event) {
    for (const item of $event) {
      if (this.listOfChecklist != null) {
        if (this.listOfChecklist.length > 0) {
          this.listOfChecklist = this.removeElemetninArray(this.listOfChecklist, item.id)
          this.listOfChecklist.push(item.id);
        }
        else {
          this.listOfChecklist.push(item.id);
        }
      }
    }
    this.filterModel.ChecklistId = this.listOfChecklist.toString();
    this.filterModel.pageNumber = '1';
    this.currentPage = 1;
    this.GetBriefingChecklist();
  }

  onDeSelectAllChecklist($event) {
    this.listOfChecklist = [];
    this.filterModel.ChecklistId = "";
    this.filterModel.pageNumber = '1';
    this.currentPage = 1;
    this.GetBriefingChecklist();
  }


  GetStatusMasterData(): void {
    this.dropdownListStatus.push(
      { "id": 1, "itemName": "✔ Done" },
      { "id": 2, "itemName": "! Needs Review" }
    );

    this.dropdownSettingsStatus = {
      singleSelection: true,
      text: "Select Status(es)",
      enableSearchFilter: true,
      classes: "borderLessTextBoxGreen",
      badgeShowLimit: 2,
      noDataLabel: 'No status available',
      showCheckbox: false,
      enableFilterSelectAll: false
    };
  }

  onSelectStatus($event) {
    this.listOfStatusIds = this.removeElemetninArray(this.listOfStatusIds, $event.id)
    this.listOfStatusIds.push($event.id);
    this.filterModel.IsDone = Number($event.id);
    this.filterModel.pageNumber = '1';
    this.currentPage = 1;
    this.GetBriefingChecklist();
  }

  onDeSelectStatus($event) {
    if (this.listOfStatusIds != null) {
      if (this.listOfStatusIds.length > 0) {
        this.listOfStatusIds = this.removeElemetninArray(this.listOfStatusIds, $event.id)
      }
    }
    this.filterModel.IsDone = 0;
    this.filterModel.pageNumber = '1';
    this.currentPage = 1;
    this.GetBriefingChecklist();
  }

  onSelectAllStatus($event) {
    for (const item of $event) {
      if (this.listOfStatusIds != null) {
        if (this.listOfStatusIds.length > 0) {
          this.listOfStatusIds = this.removeElemetninArray(this.listOfStatusIds, item.id)
          this.listOfStatusIds.push(item.id);
        }
        else {
          this.listOfStatusIds.push(item.id);
        }
      }
    }
  }

  onDeSelectAllStatus($event) {
    this.listOfStatusIds = [];
    this.filterModel.IsDone = 0;
    this.filterModel.pageNumber = '1';
    this.currentPage = 1;
    this.GetBriefingChecklist();
  }

  ExportBriefingChecklist() {
    this.isloading = true;
    this.listOfBriefingExport = [];
    this.filterModel.IsExport = true;
    this.i360service.GetBriefingChecklistV2(this.tokenKey, this.filterModel).subscribe(
      data => {
        if (data != null) {
          this.listOfBriefingExport = data['listOfChecklist'];
          if (this.listOfBriefingExport != null) {
            if (this.listOfBriefingExport.length > 0) {
              setTimeout(() => {
                this.DownloadBriefingChecklist();
                this.isloading = false;
              }, 2000);
            }
            else {
              this.isloading = false;
              this.toastr.error("No record found", "Error");
            }
          }
          else {
            this.isloading = false;
            this.toastr.error("No record found", "Error");
          }
        }
      },
      error => {
        this.isloading = false;
        console.log(error);
      }
    );
  }

  DownloadBriefingChecklist() {
    let tableData = document.getElementById("ExportTable").innerHTML;

    var uri = 'data:application/vnd.ms-excel;base64,'
      , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body>{table}</body></html>'
      , base64 = function (s) { return window.btoa(unescape(encodeURIComponent(s))) }
      , format = function (s, c) { return s.replace(/{(\w+)}/g, function (m, p) { return c[p]; }) }
    let html = "<table><tr class='mainhead'> <td colspan='3'>";
    html += tableData;
    html += "</td></tr></table>";
    let name = 'ExportBriefingsBriefingChecklist';
    var ctx = { worksheet: name || 'Worksheet', table: html }
    FileSaver.saveAs((uri + base64(format(template, ctx))), "ExportBriefingsBriefingChecklist.xls");
  }
}
